module.exports = __webpack_public_path__ + "static/media/About_Background.9174070e.png";